import { useState, useEffect } from 'react';

export function EnvironmentBadge() {
  return null; // Ocultado temporariamente para gravações do usuário
  const [hostname, setHostname] = useState('');

  useEffect(() => {
    setHostname(window.location.hostname);
  }, []);

  if (!hostname) return null;

  // Ocultar em produção, em modo aplicativo (standalone/PWA) ou nas páginas de instalação/segurança
  const isProd = hostname === 'alunoconectado.com.br' || hostname === 'www.alunoconectado.com.br';
  const isStandalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as any).standalone === true ||
    window.location.protocol === 'capacitor:' ||
    !!(window as any).Capacitor;
  const isCleanUiPage =
    window.location.pathname.toLowerCase().startsWith('/install') ||
    window.location.pathname.toLowerCase().startsWith('/security') ||
    window.location.pathname.toLowerCase().startsWith('/s/') ||
    window.location.pathname.toLowerCase().includes('/recorder');

  const isIframe = typeof window !== 'undefined' && window.self !== window.top;

  if (isProd || isStandalone || isCleanUiPage || isIframe) return null;

  // Identificar se é desenvolvimento local ou ambiente de teste
  const badgeText = 'TESTE';
  const badgeGradient = 'linear-gradient(135deg, #581c87 0%, #7e22ce 55%, #a855f7 100%)';

  return (
    <>
      <div
        className="env-badge-container"
        style={{
          position: 'fixed',
          top: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 1000000,
          userSelect: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 7,
          padding: '0 14px',
          minWidth: 88,
          height: 28,
          borderRadius: '0 0 14px 14px',
          background: badgeGradient,
          border: '1px solid rgba(255,255,255,0.86)',
          borderTop: 'none',
          color: '#ffffff',
          fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
          fontSize: '0.72rem',
          fontWeight: 800,
          letterSpacing: '0.08em',
          textShadow: '0 1px 2px rgba(0,0,0,0.2)',
          boxShadow: '0 7px 18px rgba(139, 92, 246, 0.38)',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          pointerEvents: 'none',
          animation: 'envPulse 2.8s infinite ease-in-out',
        }}
      >
        <span 
          style={{
            width: 7,
            height: 7,
            borderRadius: '50%',
            background: '#ffffff',
            display: 'inline-block',
            boxShadow: '0 0 8px #ffffff',
            flexShrink: 0,
            animation: 'envDotPulse 1.45s infinite ease-in-out',
          }}
        />
        <span 
          style={{
            position: 'relative',
            zIndex: 1,
          }}
        >
          {badgeText}
        </span>
      </div>

      <style>{`
        .env-badge-container {
          pointer-events: none;
        }
        .env-badge-container::after {
          content: "";
          position: absolute;
          inset: 0;
          transform: translateX(-125%);
          background: linear-gradient(
            90deg,
            transparent 0%,
            rgba(255,255,255,0.18) 45%,
            rgba(255,255,255,0.42) 50%,
            rgba(255,255,255,0.18) 55%,
            transparent 100%
          );
          animation: envShimmer 3.2s infinite ease-in-out;
        }
        @keyframes envPulse {
          0%, 100% {
            box-shadow: 0 7px 18px rgba(139, 92, 246, 0.34);
          }
          50% {
            box-shadow: 0 9px 26px rgba(139, 92, 246, 0.66);
          }
        }
        @keyframes envShimmer {
          0%, 45% { transform: translateX(-125%); }
          75%, 100% { transform: translateX(125%); }
        }
        @keyframes envDotPulse {
          0%, 100% {
            opacity: 0.35;
            transform: scale(0.82);
            box-shadow: 0 0 4px rgba(255,255,255,0.55);
          }
          50% {
            opacity: 1;
            transform: scale(1.18);
            box-shadow: 0 0 12px rgba(255,255,255,0.95), 0 0 22px rgba(255,255,255,0.48);
          }
        }
      `}</style>
    </>
  );
}
